import '../App.css';
import './Header.css';
import './Games.css';
import './Footer.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Home = () => {
    return (
        <div className='App'>
      <header>
        <Navbar expand="lg" className='Header-nav'>
          <Container>
            <Navbar.Brand href="/"><img alt="TheGoldApple logo, with the name written in italics" className="d-inline-block align-top Header-logo" src="https://cdn.tga.fyi/logos/tga_logo_lang_2.png"></img></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" className='Header-toggler'/>
            <Navbar.Collapse id="basic-navbar-nav" className='justify-content-end'>
                {/* <Nav.Link className='Header-button' href="/vacencies">Vacencies</Nav.Link> */}
                <Nav.Link className='Header-button' href="https://status.tga.fyi">Status</Nav.Link>
                <Nav.Link className='Header-button' href="https://thegoldapple.com/discords">Discord</Nav.Link>
                <Nav.Link className='Header-button' href="https://forum.tga.fyi">Forum</Nav.Link>
                <Nav.Link className='Header-button' href="ts3server://ts.thegoldapple.com">TS</Nav.Link>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Container>
          <Row>
            <Col className='Header-mission-statement'>
              <p>The Gold Apple isn't just any other community, it's our community. And that means that everyone in the community cares about others and the games they play. Are you our next member?</p>
              <p>You can join, and start playing today:</p>
              <div className='Header-join'>
                <p>JOIN.THEGOLDAPPLE.COM</p>
              </div>
            </Col>
          </Row>
        </Container>
        <div className='Header-fade'></div>
      </header>
      <Container className='Games'>
        <Container className='Games-tgapack'>
          <Row className='Games-row'>
            <Col className='Games-image'>
              <img alt="TGAPack logo" src="https://cdn.tga.fyi/logos/tgapack.png" className="Games-image" width="auto" height="256px"></img>
            </Col>
            <Col>
              <h1><b>TGA Pack</b></h1>
              <p>TGA Pack is our current and most up to date Minecraft modpack. This modpack has everything any one could want.</p>
              <p>Mods include:</p>
              <p><b>IC2, ICBM, Flan's, Mekanism, Thaumcraft and many more...</b></p>
              <a href="/mc/pack" class="btn btn-light">Check It Out</a> 
            </Col>
          </Row>
        </Container>
        <Container className='Games-TLB'>
          <Row className='Games-row'>
            <Col className='Games-Align-Right Games-Order-First'>
              <h1><b>TLBMilSim</b></h1>
              <p>TLBMilSim is a Arma 3 military roleplaying community, which go into battle and fight the opposing force on the frontlines of a simulated military opetation.</p>
              <p>If you would like to join, why not check it out?</p>
              <a href="https://tlbmilsim.com" class="btn btn-light">Check Us Out</a>
            </Col>
            <Col className='Games-image Games-Order-Last'>
              <img alt="TLBMilSim logo" className='Games-image' src="https://cdn.tga.fyi/logos/tlb.png" width="auto" height="256px"></img>
            </Col>
          </Row>
        </Container>
        <Container className='Games-TGARP'>
          <Row className='Games-row'>
            <Col className='Games-image'>
              <img alt="TGARP logo" className='Games-image' src="https://cdn.tga.fyi/logos/TGARP.png" width="auto" height="256px"></img>
            </Col>
            <Col>
              <h1><b>TGARP</b></h1>
              <p>TGARP is our FiveM roleplaying community. This is a community full of dedicated roleplayers, that keep in character no matter the situation.</p>
              <p>We have things like the ESX money system and other ESX scripts.</p>
              <a href="https://tgarp.xyz" class="btn btn-light">Have A Look</a>
            </Col>
          </Row>
        </Container>
        <Container className='Games-rust'>
          <Row className='Games-row'>
            <Col className='Games-Align-Right Games-Order-First'>
              <h1><b>Rust</b></h1>
              <p>The TGA Rust server is just as you would expect. Full of raiding and huge fire fights. This hektic community of players, do sometimes come together and fight arm by arm and end up taking out the rest of the server.</p>
              <p>Sounds like fun, why not have a look?</p>
              <a href="https://rust.tga.fyi" class="btn btn-light">Have A Look</a>
            </Col>
            <Col className='Games-image Games-Order-Last'>
              <img alt="TGARust logo" className='Games-image' src="https://cdn.tga.fyi/tgarust/tgaRust.png" width="auto" height="256px"></img>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container className='Footer'>
        <Row>
          <Col>
            <p>Designed and created by <a href="https://lawrencetech.uk" className='Footer-credit'><b>Lawrence Tech</b></a>, made in the UK.</p>
            <p>Copyright (c) {(new Date().getFullYear())} TheGoldApple & Lawrence Tech All Rights Reserved.</p>
            <hr />
            <p>Made with 
              <svg width="25px" height="25px" viewBox="-10.5 -9.45 21 18.9" fill="none" xmlns="http://www.w3.org/2000/svg" className="Footer-icon"><circle cx="0" cy="0" r="2" fill="currentColor"></circle><g stroke="currentColor" stroke-width="1" fill="none"><ellipse rx="10" ry="4.5"></ellipse><ellipse rx="10" ry="4.5" transform="rotate(60)"></ellipse><ellipse rx="10" ry="4.5" transform="rotate(120)"></ellipse></g></svg>
            </p>
          </Col>
          <Col className='Footer-Links'>
            <h4>Links</h4>
            <div>
              <ul>
                <li><a className='Footer-Link' href="terms">Terms and Conditions</a></li>
                <li><a className='Footer-Link' href="#about">About Us</a></li>
                <li><a className='Footer-Link' href="#styleguide">Style Guide</a></li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
    );
}

export default Home;